import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Avatar, Button, Input } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { db, auth, storage } from './firebase';
import Post from './Post';
import Logo from './logo.png';
import Home from './home.png';
import './App.css';
import Footer from './Footer';
import Profile from './UserProfile';
import AppRight from './AppRight';
import TabPanel from './components/Tab/Tab';
import PetProfile from './Pet';
import ImageUpload from './ImageUpload';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function App() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(false);
  const [openSignIn, setOpenSignIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null);
  const [image, setImage] = useState('');
  const [caption, setCaption] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        //user logged in
        console.log('----auth:', authUser);
        dispatch({
          type: 'DROPDOWN_START',
          email: authUser.email,
        });
        setUser(authUser);
        // if (image == '') {
        if (authUser.email)
          storage
            .ref(`avatars/${authUser.email}-avatar.png`)
            .getDownloadURL()
            .then((url) => {
              setImage(url);
              console.log('------AppURL:', authUser.email, url);
            });
        // }
      } else {
        //user logged out
        setUser(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [user, username]);

  // userEffect: run a piece of code based on a specific condition
  useEffect(
    () => {
      //this is where code runs
      db.collection('posts')
        .orderBy('timestamp', 'desc')
        .onSnapshot((snapshot) => {
          //every time a new post is added, it fires up onSnapshot
          setPosts(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              post: doc.data(),
            }))
          );
        });
    },
    [
      // this is condition
    ]
  );

  const signUp = (event) => {
    event.preventDefault();

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((authUser) => {
        return authUser.user.updateProfile({
          displayName: username,
        });
      })
      .catch((error) => alert(error.message));

    setOpen(false);
  };

  const signIn = (event) => {
    event.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message));

    setOpenSignIn(false);
  };
  const addImage = () => {
    document
      .getElementById('files')
      .addEventListener('change', handleChangeAvatar, false);
    document.getElementById('files').click();
  };
  const handleChangeAvatar = (e) => {
    if (e.target.files.length) {
      const files = e.target.files;
      photoUpload(files);
    }
  };
  const photoUpload = (image) => {
    const uploadTask = storage
      .ref(`avatars/${user.email}-avatar.png`)
      .put(image[0]);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // const progress = Math.round(
        //   (snapshot.bytesTransfeered / snapshot.totalBytes) * 100
        // );
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref(`avatars/${user.email}-avatar.png`)
          .getDownloadURL()
          .then((url) => {
            setImage(url);
          });
      }
    );
  };
  return (
    <div className='app'>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div style={modalStyle} className={classes.paper}>
          <form className='app_signup'>
            <center>
              <img className='app_headerImage' src={Logo} alt='' />
            </center>
            <Input
              placeholder='Username'
              type='text'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Input
              placeholder='Email'
              type='text'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder='Password (At least 6 characters)'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <br></br>
            <center>
              <Button
                variant='contained'
                color='secondary'
                size='medium'
                style={{ minWidth: '100px', maxWidth: '120px' }}
                type='submit'
                onClick={signUp}>
                Sign Up
              </Button>
            </center>
          </form>
        </div>
      </Modal>

      <Modal open={openSignIn} onClose={() => setOpenSignIn(false)}>
        <div style={modalStyle} className={classes.paper}>
          <form className='app_signup'>
            <center>
              <img className='app_headerImage' src={Logo} alt='' />
            </center>

            <Input
              placeholder='Email'
              type='text'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder='Password'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <br></br>
            <center>
              <Button
                variant='contained'
                color='secondary'
                size='medium'
                style={{ minWidth: '100px', maxWidth: '120px' }}
                type='submit'
                onClick={signIn}>
                Log In
              </Button>
            </center>
          </form>
        </div>
      </Modal>

      <div className='app_header'>
        <Button href='/' style={{ backgroundColor: 'transparent' }}>
          <img className='app_headerImage' src={Logo} alt='' />
        </Button>

        {user && (
          <div style={{ display: 'flex', width: '65%' }}>
            <Button
              href='/'
              className='app_headerbutton'
              style={{ backgroundColor: 'transparent' }}>
              <img className='app_headerhome' src={Home} alt='' />
            </Button>
            <Button href='/profile' style={{ backgroundColor: 'transparent' }}>
              <Avatar src={image} />
            </Button>
          </div>
        )}

        <div className='app_headerButton'>
          {user ? (
            <Button
              variant='contained'
              color='secondary'
              size='medium'
              style={{ minWidth: '100px', maxWidth: '120px' }}
              onClick={() => auth.signOut()}>
              Log out
            </Button>
          ) : (
            <div className='app_loginContainer'>
              <div className='buttons'>
                <Button
                  variant='contained'
                  color='secondary'
                  size='medium'
                  style={{ minWidth: '100px', maxWidth: '120px' }}
                  onClick={() => setOpenSignIn(true)}>
                  Log In
                </Button>
              </div>
              <div className='buttons'>
                <Button
                  variant='contained'
                  color='secondary'
                  size='medium'
                  style={{ minWidth: '100px', maxWidth: '120px' }}
                  onClick={() => setOpen(true)}>
                  Sign Up
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className='app_posts'>
        <div className='app_postLeft'>
          {user && (
            <div className='card card-1'>
              <div style={{ display: 'flex', padding: '3%' }}>
                <input type='file' id='files' style={{ display: 'none' }} />

                {user && (
                  <Button component='label'>
                    <Avatar
                      style={{ width: '50px', height: '50px' }}
                      src={image}
                    />
                    <button
                      style={{ display: 'none' }}
                      onClick={addImage}></button>
                  </Button>
                )}
                <div
                  style={{
                    paddingLeft: '5%',
                    paddingTop: '3%',
                    height: '48px',
                    width: '80%',
                    margin: '0, auto',
                  }}>
                  <input
                    placeholder='enter a caption'
                    className='caption'
                    onChange={(e) => setCaption(e.target.value)}
                    style={{
                      // backgroundColor: 'white',
                      backgroundColor: '#eae8e8',
                      borderRadius: '14px',
                      borderColor: 'rgba(0, 0, 0, 0.26)',
                      height: '100%',
                      paddingLeft: '4%',
                      width: '100%',
                      margin: '0, auto',
                    }}></input>
                </div>
              </div>
              <hr style={{ width: '93%', marginLeft: '3%' }}></hr>
              <div style={{ display: 'flex' }}>
                {user && (
                  <ImageUpload
                    usercaption={caption}
                    username={user.displayName}
                    useremail={user.email}
                  />
                )}
                {/* <Avatar src={image} /> */}
              </div>
            </div>
          )}
          { user && <br></br>}
          { user && <br></br> }
          {posts.map(({ id, post }) => (
            <Post
              className='post'
              key={id}
              postId={id}
              count={post.count ? post.count : 0}
              user={user}
              username={post.username}
              caption={post.caption}
              imageUrl={post.imageUrl}
              imageName={post.imagename}
              email={post.useremail}
            />
          ))}
        </div>

        {/* <div className='app_profileRight'>
          {user ? (
            <TabPanel>
              <div title='User Profile'>
                {user ? (
                  <Profile
                    username={user.displayName}
                    email={user.email}
                    posts={user.posts}
                    user={user}
                  />
                ) : (
                  <AppRight />
                )}
              </div>
              <div title='Pet Profile'>
                {user ? (
                  <PetProfile
                    username={user.displayName}
                    email={user.email}
                    posts={user.posts}
                    user={user}
                  />
                ) : (
                  <AppRight />
                )}
              </div>
            </TabPanel>
          ) : (
            <AppRight />
          )}
        </div> */}
      </div>
      <Footer />
    </div>
  );
}

export default App;
